import React from 'react';

function formatColones(valor: number): string {
  return `₡${valor.toLocaleString('es-CR')}`;
}

interface BetSummaryProps {
  numero: string;
  montoDirec: number;
  montoRev: number;
  esReventado: boolean;
  canAdd: boolean;
  onAdd: () => void;
}

export const BetSummary: React.FC<BetSummaryProps> = ({
  numero,
  montoDirec,
  montoRev,
  esReventado,
  canAdd,
  onAdd,
}) => {
  const total = montoDirec + montoRev;

  return (
    <div className="space-y-3">
      {/* Summary row */}
      <div className="bg-gray-800/60 rounded-xl border border-gray-700 px-4 py-3">
        <div className="flex items-center justify-between text-sm">
          <div className="flex items-center gap-4">
            <div className="text-center">
              <p className="text-gray-500 text-[10px] uppercase">Numero</p>
              <p className="text-white font-mono font-bold text-lg">{numero || '--'}</p>
            </div>
            <div className="text-center">
              <p className="text-gray-500 text-[10px] uppercase">Directo</p>
              <p className="text-blue-400 font-bold">{formatColones(montoDirec)}</p>
            </div>
            {esReventado && (
              <div className="text-center">
                <p className="text-gray-500 text-[10px] uppercase">Reventado</p>
                <p className="text-purple-400 font-bold">{formatColones(montoRev)}</p>
              </div>
            )}
          </div>
          <div className="text-right">
            <p className="text-gray-500 text-[10px] uppercase">Total</p>
            <p className="text-amber-400 font-bold text-lg">{formatColones(total)}</p>
          </div>
        </div>
      </div>

      {/* Add button */}
      <button
        type="button"
        onClick={onAdd}
        disabled={!canAdd}
        className={`w-full py-4 font-bold text-lg rounded-xl transition-all ${
          canAdd
            ? 'bg-blue-600 hover:bg-blue-500 active:bg-blue-700 text-white'
            : 'bg-gray-800 text-gray-600 cursor-not-allowed'
        }`}
      >
        + Agregar jugada
      </button>
    </div>
  );
};
